import React from 'react';

import ApproveStep from "./approve"

export default [
    { path: '/approval/steps/:id/approve', component: ApproveStep, name: 'Approval Step' }
]

